var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { NGXLogger } from 'ngx-logger';
import { ApiService } from '../../../service/api.service';
import { ContentBaseService } from '../../../component/base/contentbase.service';
var DisplayTargetService = /** @class */ (function (_super) {
    __extends(DisplayTargetService, _super);
    function DisplayTargetService(logger, api) {
        var _this = _super.call(this, logger, api) || this;
        _this.logger = logger;
        _this.api = api;
        _this.segment = [];
        return _this;
    }
    DisplayTargetService.prototype.getSegmentList = function () {
        var _this = this;
        this.baseUrl = '/v1/gen/segment-m-service?query={"orderByList":[{"name":"cdate","direction":"desc"}],"predicateList":[{"name":"segment_set_m.segment_set_id","operator":"isNull"}]}';
        return _super.prototype.getRecord.call(this).pipe(map(function (data) {
            var options = [];
            for (var _i = 0, _a = data.items; _i < _a.length; _i++) {
                var item = _a[_i];
                options.push({ code: item.segment_id, display: item.segment_title });
            }
            _this.logger.debug('options:', options);
            _this.segment = options;
            return options;
        }));
    };
    DisplayTargetService.prototype.getSegment = function () {
        return this.segment;
    };
    DisplayTargetService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    DisplayTargetService.ctorParameters = function () { return [
        { type: NGXLogger },
        { type: ApiService }
    ]; };
    return DisplayTargetService;
}(ContentBaseService));
export { DisplayTargetService };
//# sourceMappingURL=target.service.js.map